<div class="container">
  <h1 mat-dialog-title>Change Location </h1>
  <div mat-dialog-content>
    <mat-form-field class="w-100" floatPlaceholder="never" >
      <mat-label>Location Code</mat-label>
      <input matInput [matAutocomplete]="auto" class="ta-LocationDropDown-locationcode" (input)="searchText()" [formControl]="locationAutocomplete"
          (click)="onFocus($event);" (blur)="onBlur($event);" data-hj-whitelist>
      <mat-autocomplete #auto="matAutocomplete">
          <mat-spinner [style.display]="showSpinner ? 'block' : 'none'"></mat-spinner>
          <mat-option [style.display]="showSpinner ?  'none':'block' "
              *ngFor="let settings of filteredLocations | async" [value]="settings.code" [ngClass]="'ta-LocationDropDown-location-' + settings.code.toLowerCase()"
              (onSelectionChange)="getitem($event, settings)">
              <span>{{ settings.code }}</span> |
              <small>{{settings.description}}</small>
      
          </mat-option>
      </mat-autocomplete>
  </mat-form-field>

  </div>
  <div mat-dialog-actions>
    <button mat-button class="mat-mdc-button-RedBackground-WhiteText text-white btn btn-danger"  (click)="onCancelClick()">Cancel</button>
    <button mat-button class="magin_5 text-white btn btn-'+globals.colorTheme" (click)="onSaveClick()">Save</button>
    
  </div>
</div>